import { css } from 'react-emotion';

export const link = css`
	display: inline-block;
	flex: 1 0 auto;
	font-size: 0.875rem;
	font-weight: 300;
	margin-left: 1rem;
	text-align: right;
`;

export const linkHeader = css`
	display: inline-block;
	flex: 1 0 auto;
	font-size: 1.2rem;
	font-weight: 300;
	margin-left: 1rem;
	text-align: right;

	@media (max-width: 500px) {
		display: block;
		width: 100%;
		margin-top: 10px;
		margin-left: 0;
		text-align: left;
	}
`;
